import { Methods } from "@newview/infrastructure";
import {NewviewOaBaseApi} from "./NewviewOaBaseApi";


export class JobNormDictionaryApi extends NewviewOaBaseApi {

  public get ControllerName(): any {
    return 'job-norm-dictionary'
  }

}